module.exports = __webpack_public_path__ + "img/icon-warning-circle.61fcd9f8.svg";